import { ApiModel } from "./api-model";

export class Market extends ApiModel {
  name: string;
  editors: string[];
}



// WEBPACK FOOTER //
// ./src/app/models/market.ts